// skeleton/app/src/app/shared/components/incident-consent-sign-dialog/consent-sign-dialog.component.ts

import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CreateSurvey } from '../page/page.model';
import { environment } from 'src/environments/environment';
import { QuestionViewModel } from '../../models/questionview.model';
import { NotificationService } from '../../services/notifications.service';
import { StorageService } from '../../services/token-storage.service';
import { AppConstants } from '../../appconstants';

@Component({
  selector: 'app-consent-sign-dialog',
  templateUrl: './consent-sign-dialog.component.html',
  styleUrl: './consent-sign-dialog.component.scss',
  standalone: false,
})
export class ConsentSignDialogComponent {
  consentSignPopUpHeaderHtmlContent: string = '';
  appConstants: AppConstants = new AppConstants();

  allConsentQuestions: QuestionViewModel[] = [];
  consentSignQuestions: QuestionViewModel[] = [];
  surveyViewModel: CreateSurvey = new CreateSurvey();
  valid: boolean = false;

  @Output() responseChanged = new EventEmitter<any>();

  showError: boolean = false;
  loggedInUserMailId: string = '';
  userMailId: string = '';

  constructor(
    public dialogRef: MatDialogRef<ConsentSignDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { surveyViewModel: CreateSurvey; consentQuestions: QuestionViewModel[]; selectedChild: any },
    private notificationService: NotificationService,
    private storage: StorageService
  ) {
    this.surveyViewModel = data.surveyViewModel;
    this.allConsentQuestions = data.consentQuestions;
  }

  ngOnInit() {
    this.consentSignQuestions = this.allConsentQuestions.filter((q) => q.inputType === 'sign');
    this.setConsentSignContent();
    this.updateResponseText();
  }

  setConsentSignContent() {
    const providerType = this.storage.get('LoggedInProviderType');
    if (providerType === this.appConstants.providerTypes.RESIDENTIAL_PROVIDER) {
      this.consentSignPopUpHeaderHtmlContent = environment.consentSignPopUpHeaderHtmlContentForRS;
    }
    else if( providerType === this.appConstants.providerTypes.Demo){
      this.consentSignPopUpHeaderHtmlContent = environment.consentSignPopUpHeaderHtmlContentDemo;
    } else {
      this.consentSignPopUpHeaderHtmlContent = environment.consentSignPopUpHeaderHtmlContent;
    }
  }

  updateResponseText() {
    this.loggedInUserMailId = this.storage.get('LoggedInuserMailId');

    this.consentSignQuestions.forEach((q) => {
      if (q.responseText && q.responseText.length > 0) {
        try {
          const signDet = JSON.parse(q.responseText);
          const data = (signDet?.['key'] || '').split('||');
          this.userMailId = data?.[2];

          if (this.loggedInUserMailId && this.loggedInUserMailId !== this.userMailId) {
            q.responseText = '';
            delete (q as any)['responseText'];
          }
        } catch {
          q.responseText = '';
          delete (q as any)['responseText'];
        }
      }
    });
  }

  close() {
    this.dialogRef.close();
  }

  UpdateResponse(event: any) {
    const selectedChild = event;
    this.showError = false;

    if (this.consentSignQuestions?.length > 0) {
      this.consentSignQuestions.forEach((element: QuestionViewModel) => {
        if (element.questionId === selectedChild.questionId) {
          Object.assign(element, selectedChild);
        }
      });
    }

    this.valid = !!selectedChild?.IsValid;
    this.responseChanged.emit(selectedChild);
  }

  ok() {
    this.showError = false;

    const signAvailable: boolean = this.checkAtleastOneSignAvailable();
    if (this.valid && signAvailable) {
      this.dialogRef.close({ isConsentAccepted: true });
    } else if (!signAvailable) {
      this.showError = true;
    } else {
      this.notificationService.showError('Please E-sign your application before submission', 'Error');
    }
  }

  checkAtleastOneSignAvailable() {
    return this.consentSignQuestions.length > 0 && this.consentSignQuestions.some((q) => q.responseText);
  }
}
